var _rect, _path, _rect2, _rect3, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyLibraryColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.05273,
    y: 4.32812,
    width: 3.73333,
    height: 15.8667,
    rx: 0.466667,
    fill: "#87F0AE",
    stroke: "#87F0AE",
    strokeWidth: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16.1992H11.2701",
    stroke: "white",
    strokeWidth: 1.05,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.792,
    y: 4.48242,
    width: 3.84533,
    height: 16.0847,
    rx: 0.466667,
    transform: "rotate(-11.1716 12.792 4.48242)",
    fill: "#9B9BFF",
    stroke: "#9B9BFF",
    strokeWidth: 1.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.31934,
    y: 4.32812,
    width: 3.73333,
    height: 15.8667,
    rx: 0.466667,
    fill: "#FFE26C",
    stroke: "#FFE26C",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61133 16.1992H7.76133",
    stroke: "white",
    strokeWidth: 1.05,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.418 16.1992L18.4975 15.5364",
    stroke: "white",
    strokeWidth: 1.05,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLibraryColor);
export default __webpack_public_path__ + "static/media/MyLibraryColor.81ba3efdf5288043c83d058633f80d10.svg";
export { ForwardRef as ReactComponent };